import type { PageContext } from 'vike/types'
export default function title(pageContext: PageContext): string {
  return pageContext.i18n.global.t('seo.home.title')
}
